import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const orderAdditionalCostLineItemReasonsAdapter = getAdapter({ idFieldName: 'value' });

const orderAdditionalCostLineItemReasonsSlice = createSlice({
    name: 'orderAdditionalCostLineItemReasons',
    initialState: orderAdditionalCostLineItemReasonsAdapter.getInitialState(),
    reducers: {
        setOrderAdditionalCostLineItemReasons: (state, { payload: { orderAdditionalCostLineItemReasons } }) => {
            orderAdditionalCostLineItemReasonsAdapter.setAll(state, orderAdditionalCostLineItemReasons);
        },
    },
});

const selectors = orderAdditionalCostLineItemReasonsAdapter.getSelectors(({ orderAdditionalCostLineItemReasons }) => orderAdditionalCostLineItemReasons);

export const getOrderAdditionalCostLineItemReasons = (state) => selectors.selectAll(state);

export const {
    setOrderAdditionalCostLineItemReasons,
} = orderAdditionalCostLineItemReasonsSlice.actions;

export default orderAdditionalCostLineItemReasonsSlice.reducer;
